import LogoLockup from '@components/logo-lockup';
import * as React from 'react';
export default {
  LogoLockup,
  React
};